import React from "react";
import ServiceGroupsCard, { DraftServiceGroup } from "../ServiceGroupsCard";
export function ServiceGroupsStep({
  serviceId,
  groups,
  onChange,
}: {
  serviceId?: number;
  groups: DraftServiceGroup[];
  onChange: (groups: DraftServiceGroup[]) => void;
}) {
  return (
    <ServiceGroupsCard
      serviceId={serviceId}
      draftGroups={groups}
      onDraftGroupsChange={onChange}
    />
  );
}
